export const performanceReport = {
  id: 3079,
  name: 'Recruiter performance',
  description: '',
  visibility: 'private',
  subject_type: 'recruiter_performance',
  layout: {
    data: [
      {
        h: 7,
        w: 3,
        x: 9,
        y: 0,
        key: '7036',
        maxH: 13,
        maxW: 4,
        minH: 7,
        minW: 3,
      },
      {
        h: 7,
        w: 3,
        x: 0,
        y: 7,
        key: '7037',
        maxH: 13,
        maxW: 4,
        minH: 7,
        minW: 3,
      },
      {
        h: 7,
        w: 3,
        x: 6,
        y: 7,
        key: '7038',
        maxH: 13,
        maxW: 4,
        minH: 7,
        minW: 3,
      },
      {
        h: 7,
        w: 3,
        x: 9,
        y: 7,
        key: '7039',
        maxH: 13,
        maxW: 4,
        minH: 7,
        minW: 3,
      },
      {
        h: 7,
        w: 3,
        x: 0,
        y: 0,
        key: '7040',
        maxH: 13,
        maxW: 4,
        minH: 7,
        minW: 3,
      },
      {
        h: 7,
        w: 3,
        x: 3,
        y: 0,
        key: '7041',
        maxH: 13,
        maxW: 4,
        minH: 7,
        minW: 3,
      },
      {
        h: 7,
        w: 3,
        x: 6,
        y: 0,
        key: '7042',
        maxH: 13,
        maxW: 4,
        minH: 7,
        minW: 3,
      },
      {
        h: 7,
        w: 3,
        x: 3,
        y: 7,
        key: '7043',
        maxH: 13,
        maxW: 4,
        minH: 7,
        minW: 3,
      },
      {
        h: 18,
        w: 12,
        x: 0,
        y: 14,
        key: '7044',
        maxH: 100,
        maxW: 12,
        minH: 10,
        minW: 8,
      },
    ],
  },
  filters: null,
  tiles: [
    {
      id: 7036,
      subject_type: 'recruiter_performance',
      metadata: {
        id: 'offers_sent',
        tileKey: 'offers_sent',
        apiParam: 'card',
        headerKey: 'offers_sent',
        componentType: 'card',
        uniqueTrackingId: 'offers_1760602241026_sffej1psm',
      },
      query: null,
    },
    {
      id: 7037,
      subject_type: 'recruiter_performance',
      metadata: {
        id: 'offers_accepted',
        unit: 'percent',
        tileKey: 'offers_accepted',
        apiParam: 'card',
        metricKeys: {
          numerator: 'offers_accepted',
          denominator: 'offers_sent',
        },
        componentType: 'card',
        calculationType: 'rateOfChange',
        uniqueTrackingId: 'offers_1760602241026_6skxy1i2x',
      },
      query: null,
    },
    {
      id: 7038,
      subject_type: 'recruiter_performance',
      metadata: {
        id: 'time_to_hire',
        unit: 'time',
        tileKey: 'time_to_hire',
        apiParam: 'card',
        metricKeys: {
          numerator: 'time_to_hire',
          denominator: 'hired_candidates',
        },
        componentType: 'card',
        calculationType: 'avgChange',
        uniqueTrackingId: 'hires_1760602241026_b16on2eo8',
      },
      query: null,
    },
    {
      id: 7039,
      subject_type: 'recruiter_performance',
      metadata: {
        id: 'rejected_candidates',
        tileKey: 'rejected_candidates',
        apiParam: 'card',
        headerKey: 'rejected_candidates',
        componentType: 'card',
        uniqueTrackingId: 'recruiter_performance_1760602241026_gdtpdh24g',
      },
      query: null,
    },
    {
      id: 7040,
      subject_type: 'recruiter_performance',
      metadata: {
        id: 'sourced_candidates',
        tileKey: 'sourced_candidates',
        apiParam: 'card',
        headerKey: 'sourced_candidates',
        componentType: 'card',
        uniqueTrackingId: 'recruiter_performance_1760602241026_0w8jcgvvd',
      },
      query: null,
    },
    {
      id: 7041,
      subject_type: 'recruiter_performance',
      metadata: {
        id: 'screened_candidates',
        tileKey: 'screened_candidates',
        apiParam: 'card',
        headerKey: 'screened_candidates',
        componentType: 'card',
        uniqueTrackingId: 'recruiter_performance_1760602241026_f41b53aen',
      },
      query: null,
    },
    {
      id: 7042,
      subject_type: 'recruiter_performance',
      metadata: {
        id: 'interviews_scheduled',
        tileKey: 'interviews_scheduled',
        apiParam: 'card',
        headerKey: 'interviews_scheduled',
        componentType: 'card',
        uniqueTrackingId: 'recruiter_performance_1760602241026_c26ff84do',
      },
      query: null,
    },
    {
      id: 7043,
      subject_type: 'recruiter_performance',
      metadata: {
        id: 'hired_candidates',
        tileKey: 'hired_candidates',
        apiParam: 'card',
        headerKey: 'hired_candidates',
        componentType: 'card',
        uniqueTrackingId: 'recruiter_performance_1760602405570_n3l9ftc14',
      },
      query: null,
    },
    {
      id: 7044,
      subject_type: 'recruiter_performance',
      metadata: {
        id: 'recruiter_performance_table',
        title: 'Recruiter performance',
        filters: {
          group_by_1: {
            id: 'action_performed_by_user',
            key: 'user',
            label: 'User',
          },
          group_by_2: {
            id: null,
            label: 'None',
          },
        },
        tileKey: 'recruiter_performance_table',
        apiParam: 'chart_table',
        headerKeys: [
          'sourced_candidates',
          'screened_candidates',
          'interviews_scheduled',
          'interviews_conducted',
          'interviews_rescheduled',
          'interviews_cancelled',
          'offers_sent',
          'offers_accepted',
          'time_to_offer',
          'offer_revisions_done',
          'hired_candidates',
          'time_to_hire',
          'rejected_candidates',
        ],
        componentType: 'table',
        uniqueTrackingId: 'recruiter_performance_1760602544603_xt0sn6gpa',
      },
      query: null,
    },
  ],
  user: {
    id: 808,
  },
};
